import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import './checkbox.css';
import NumberField from '../number_field/number_field';

var Checkbox = function (_Component) {
	_inherits(Checkbox, _Component);

	function Checkbox() {
		_classCallCheck(this, Checkbox);

		var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this));

		_this.state = {
			quantity: 1
		};
		_this.handleChange = _this.handleChange.bind(_this);
		_this.setQuantity = _this.setQuantity.bind(_this);
		return _this;
	}

	_createClass(Checkbox, [{
		key: 'setQuantity',
		value: function setQuantity(quantity, checked) {
			if (checked) {
				this.setState({ quantity: quantity });
			} else {
				this.setState({ quantity: 1 });
			}
		}
	}, {
		key: 'handleChange',
		value: function handleChange(e) {
			console.log("THIS IS HNDS", e.currentTarget.checked);
			if (e.currentTarget.checked === false) {
				this.setState({ quantity: 1 });
			}
			var onChange = this.props.onChange;

			if (onChange == null) {
				return;
			}

			onChange(e.currentTarget.checked);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    disabled = _props.disabled,
			    label = _props.label,
			    id = _props.id,
			    itemAction = _props.itemAction,
			    shopify_product_title = _props.shopify_product_title,
			    checked = _props.checked,
			    show_quantity = _props.show_quantity,
			    value = _props.value,
			    updateQuantity = _props.updateQuantity;


			var printed_value = value === 'Default Title' ? shopify_product_title : value;

			var state_quantity = this.state.state_quantity;


			return React.createElement(
				'div',
				{ className: 'Checkbox' },
				React.createElement('input', {
					tabIndex: '0',
					type: 'checkbox',
					id: id,
					disabled: disabled,
					value: label,
					checked: checked,
					quantity: this.state.quantity,
					onChange: function onChange(e) {
						_this2.handleChange(e);if (itemAction) {
							itemAction(checked, value, label, shopify_product_title, state_quantity);
						}
					} }),
				React.createElement(
					'label',
					{ className: 'checkbox-label', htmlFor: id },
					printed_value
				),
				checked && show_quantity && React.createElement(NumberField, {
					itemAction: function itemAction(quantity) {
						_this2.setQuantity(quantity, checked);if (updateQuantity) {
							updateQuantity(quantity, value);
						}
					}
				})
			);
		}
	}]);

	return Checkbox;
}(Component);

export default Checkbox;